module.exports = __webpack_public_path__ + "images/halloween_lp/campaign_date_d928fa472d394821c5d527154e41d8ca.png";